import { Component, OnInit, Input } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Composant de bouton de confirmation
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-bouton-confirmation',
  templateUrl: './bouton-confirmation.component.html',
  styleUrls: ['./bouton-confirmation.component.css']
})
export class BoutonConfirmationComponent extends BaseComponent implements OnInit {

    @Input("activerConfirmation") activerConfirmation: boolean = true;
    @Input("confirmation") libelleConfirmation: string = '';
    @Input("confirmer") libelleConfirmer: string = '';
    @Input("annuler") libelleAnnuler: string = '';
    @Input("fonction") fonctionCallback: Function = () => { };
    @Input("typeMessage") typeMessage: string = 'danger';

    public afficherConfirmation: boolean = false;

    /**
     * Constructeur
     */
    constructor() { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Clic sur le bouton
     */
    public clicBouton() {
        if (this.activerConfirmation) {
            this.afficherConfirmation = true;
        }
        else {
            this.fonctionCallback();
        }
    }

    /**
     * Clic sur le bouton confirmer
     */
    public clicConfirmer() {
        this.fonctionCallback();
        this.afficherConfirmation = false;
    }

    /**
     * Clic sur le bouton annuler
     */
    public clicAnnuler() {
        this.afficherConfirmation = false;
    }

    /**
     * R�initialiser la confirmation
     */
    public resetConfirmation() {
        this.afficherConfirmation = false;
    }
}
